export default function getMetaFields(metaSettings){
  return metaSettings.get('meta_fields')
    .sortBy( e => e.get('sorder') )
    .mapEntries( ( [, metaField]) => [metaField.get('field').get('key'), metaField.toJS() ] )
    .toJS()
}